import HomeView from './HomeView';
import OldView from './OldView';

export { HomeView, OldView };



/** WEBPACK FOOTER **
 ** ./src/modules/home/index.js
 **/